import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MentionsInput from './MentionsInput';
import Dropdown from './Dropdown';
import Avatar from './Avatar';
import axios from '../lib/axios';
import qs from 'qs';

export default class CommentCard extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    author: PropTypes.object.isRequired,
    body: PropTypes.string.isRequired,
    body_markdown: PropTypes.string.isRequired,
    replyUrl: PropTypes.string,
    parent_id: PropTypes.string,
    isLeaf: PropTypes.bool,
    children: PropTypes.array.isRequired,
    is_favorited: PropTypes.bool.isRequired,
    vote_count: PropTypes.number.isRequired,
    toggle_favorite_url: PropTypes.string.isRequired,
    posted_on_words: PropTypes.string.isRequired,
    posted_on: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    dropdown_items: PropTypes.array,
    api_user_url: PropTypes.string.isRequired,
    api_company_url: PropTypes.string.isRequired,
    onReplyClick: PropTypes.func,
    highlighted: PropTypes.bool,
  };

  static defaultProps = {
    dropdown_items: [],
    isLeaf: false,
    parent_id: null,
    replyUrl: null,
    highlighted: false,
    onUpdate: () => {},
    onDelete: () => {},
    onReplyClick: () => {},
  };

  constructor(props) {
    super(props);

    this.commentTextAreaRef = React.createRef();
    this.replyTextAreaRef = React.createRef();

    this.state = {
      replying: false,
      editing: false,
      is_favorited: this.props.is_favorited,
      vote_count: this.props.vote_count,
      commentValue: this.props.body,
      replyValue: null,
      highlighted: this.props.highlighted,
    };
  }

  handleSubmitReply = (e) => {
    e.preventDefault();
    if (this.state.replyValue !== '') {
      axios
        .post(this.props.replyUrl, {
          comment: { body: this.state.replyValue, parent_id: this.props.id },
        })
        .then((response) => {
          this.props.onUpdate(response.data);
          this.setState({ replyValue: null, replying: false });
        });
    }
  };

  handleUpdateComment = (e) => {
    e.preventDefault();
    if (this.state.commentValue !== '') {
      axios.put(this.props.url, { comment: { body: this.state.commentValue } }).then((response) => {
        this.props.onUpdate(response.data);
        this.setState({ commentValue: this.props.body, editing: false });
      });
    }
  };

  handleCommentValueChange = (value) => {
    this.setState({ commentValue: value });
  };
  handleReplyValueChange = (value) => {
    this.setState({ replyValue: value });
  };

  handleCommentDropdownClick = (item) => {
    if (item['data-method'] === 'update') {
      this.setState({ editing: true });
    } else if (item['data-method'] === 'delete' && confirm(item['data-confirm'])) {
      axios.delete(item.url).then((response) => this.props.onDelete(response.data));
    }
  };

  handleFavoriteClick = () => {
    axios.get(this.props.toggle_favorite_url).then(() => {
      this.setState({
        is_favorited: !this.state.is_favorited,
        vote_count: this.state.is_favorited ? this.state.vote_count - 1 : this.state.vote_count + 1,
      });
    });
  };

  handleReplyClick = (replyTo) => {
    if (this.props.parent_id !== null) {
      this.props.onReplyClick(replyTo);
    } else {
      this.setState({ replying: true, replyValue: `@${replyTo} ` });
    }
  };

  handleCancelReplyClick = () => {
    this.setState({ replying: false });
  };

  handleCancelEditClick = () => {
    this.setState({ editing: false });
  };

  renderAvatar(commenter, extraClass = null) {
    return (
      <Avatar
        src={commenter.avatar}
        href={commenter.url}
        name={commenter.name}
        className={`${extraClass}`}
        key={commenter.url}
      />
    );
  }

  renderDropdownTrigger() {
    return (
      <span className="u-text-grey">
        <i className="Icon-more u-flex u-color-grey u-items-center u-text-sm" />
      </span>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.editing !== this.state.editing && this.state.editing) {
      this.commentTextAreaRef.current.focus();
    } else if (prevState.replying !== this.state.replying && this.state.replying) {
      const length = this.replyTextAreaRef.current.value.length;
      this.replyTextAreaRef.current.focus();
      this.replyTextAreaRef.current.setSelectionRange(length, length);
    }
  }

  componentDidMount() {
    const params = qs.parse(window.location.search.slice(1));
    if (params.comment && params.comment === this.props.id) {
      this.setState({ highlighted: true });
    }
  }

  renderComment = () => {
    return (
      <div>
        <div className="u-flex u-items-center u-relative">
          <a
            href={this.props.author.url}
            className="u-font-semibold u-leading-none u-mb-1 u-text-base">
            {this.props.author.name}
          </a>
          <div className="u-text-grey u-text-sm u-ml-2 u-leading-none" title={this.props.posted_on}>
            {this.props.posted_on_words}
          </div>
          {this.props.dropdown_items.length > 0 && (
            <div className="u-top-0 u-right-0 u-absolute u--mt-1">
              <Dropdown
                contentClassName="dropdown-card"
                listClassName="u-text-old-primary-color-blue u-text-sm"
                renderTrigger={this.renderDropdownTrigger}
                addMarginTop={false}
                asyncCallback={this.handleCommentDropdownClick.bind(this)}
                items={this.props.dropdown_items}
              />
            </div>
          )}
        </div>
        <div className="u-flex u-w-full u-items-start u-justify-between u-mb-1">
          <div
            dangerouslySetInnerHTML={{ __html: this.props.body_markdown }}
            className="Card-comment Readability"
          />
        </div>
        <div className="u-flex u-items-center u-justify-between">
          <div className="u-flex u-items-start">
            <div
              onClick={this.handleReplyClick.bind(this, this.props.author.slug)}
              className="u-flex u-items-center u-text-xs u-text-old-primary-color-blue u-mr-2 u-cursor-pointer">
              <i className="Icon-comment u-flex u-mr-1 u-items-center" />
              <span style={{ paddingBottom: '2px' }}>Reply</span>
            </div>
            <div
              onClick={this.handleFavoriteClick}
              className="u-flex u-items-center u-text-xs u-text-old-primary-color-blue u-cursor-pointer">
              {this.state.is_favorited && (
                <i className="Icon-favorite-full u-flex u-items-center u-mr-1" />
              )}
              {!this.state.is_favorited && (
                <i className="Icon-favorite u-flex u-items-center u-mr-1" />
              )}
              <span>Favorite</span>
            </div>
          </div>
          <div className="u-hidden u-items-center sm:u-flex">
            {!this.props.isLeaf && (
              <span className="u-text-xs u-text-grey u-mr-2">
                {this.props.children.length !== 1
                  ? `${this.props.children.length} comments`
                  : '1 comment'}
              </span>
            )}
            <span className="u-text-xs u-text-grey u-mr-2">
              {this.state.vote_count !== 1 ? `${this.state.vote_count} favorites` : '1 favorite'}
            </span>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div
        key={this.props.id}
        className={`Card-comment u-items-top u-flex u-items-start u-my-2 u-pb-2 u-border-b u-border-grey-lighter ${
          this.state.highlighted ? 'highlight-fadeout' : ''
        }`}
        id={`comment-${this.props.id}`}>
        <div className="u-mr-4">{this.renderAvatar(this.props.author, 'u-h-8 u-w-8')}</div>
        <div className="u-w-full">
          <div className={`${this.state.editing ? 'u-flex' : 'u-hidden'} u-w-full`}>
            <form
              onSubmit={this.handleUpdateComment.bind(this)}
              className="u-w-full u-flex u-items-center">
              <MentionsInput
                style={{ minHeight: 30 }}
                isComment
                toolbarAlwaysInvisible
                rows={1}
                clear={this.state.editing}
                value={this.state.commentValue}
                onChange={(value) => this.handleCommentValueChange(value)}
                innerRef={this.commentTextAreaRef}
                apiUserUrl={this.props.api_user_url}
                apiCompanyUrl={this.props.api_company_url}
                placeholder="Add a comment..."
                className="u-w-full u-mb-0 u-border-grey-lighter u-rounded u-resize-none"
              />
              <div className="u-ml-3 u-flex u-flex-col u-items-center u-justify-center">
                <button className="Button Button--tiny Button--noMargins" type="submit">
                  Update
                </button>
                <span
                  className="u-cursor-pointer u-text-grey hover:u-underline u-text-xs"
                  onClick={this.handleCancelEditClick}>
                  Cancel
                </span>
              </div>
            </form>
          </div>
          <div>
            {!this.state.editing && this.renderComment()}
            <div>
              {this.props.children.length > 0 &&
                this.props.parent_id === null &&
                this.props.children.map((childComment) => (
                  <CommentCard
                    {...childComment}
                    isLeaf
                    onUpdate={this.props.onUpdate}
                    onDelete={this.props.onDelete}
                    onReplyClick={this.handleReplyClick}
                    key={childComment.id}
                  />
                ))}
            </div>
            {this.state.replying && this.props.parent_id === null && (
              <form
                onSubmit={this.handleSubmitReply.bind(this)}
                className="u-w-full u-flex u-items-center">
                <MentionsInput
                  style={{ minHeight: 30 }}
                  isComment
                  toolbarAlwaysInvisible
                  rows={1}
                  clear={this.state.replying}
                  value={this.state.replyValue}
                  onChange={(value) => this.handleReplyValueChange(value)}
                  innerRef={this.replyTextAreaRef}
                  apiUserUrl={this.props.api_user_url}
                  apiCompanyUrl={this.props.api_company_url}
                  placeholder="Add a comment..."
                  className="u-w-full u-mb-0 u-border-grey-lighter u-rounded u-resize-none"
                />
                <div className="u-ml-3 u-flex u-flex-col u-items-center u-justify-center">
                  <button className="Button Button--tiny  Button--noMargins" type="submit">
                    Reply
                  </button>
                  <span
                    className="u-cursor-pointer u-text-grey hover:u-underline u-text-xs"
                    onClick={this.handleCancelReplyClick}>
                    Cancel
                  </span>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }
}
